import React from "react";
import { FaDesktop, FaMobileAlt, FaStopwatch } from "react-icons/fa";

const HERO_IMAGE = "https://cdn.cultura.com/cdn-cgi/image/width=830/media/pim/TITELIVE/16_9782732479408_1_75.jpg";

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-[1.5rem] border border-white/10 bg-white/10 p-4 text-white backdrop-blur-xl">
      <Icon className="text-blue-200" />
      <p className="mt-3 text-2xl font-bold">{value}</p>
      <p className="text-xs font-bold uppercase tracking-[0.14em] text-white/50">
        {label}
      </p>
    </div>
  );
}

function ScoreboardHero() {
  return (
    <header className="relative overflow-hidden bg-slate-950">
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Tableau de score judo"
          className="h-full w-full object-cover opacity-75"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-950/80 to-blue-950/75" />
      </div>

      <div className="relative mx-auto flex min-h-[380px] w-full max-w-[1280px] flex-col justify-end px-4 pb-20 pt-12 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white backdrop-blur-xl">
            <FaStopwatch />
            Arbitrage & score
          </div>

          <h1 className="mt-5 font-titre text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Tableau de score de judo
          </h1>

          <p className="mt-5 max-w-2xl text-base font-medium leading-8 text-white/75 sm:text-lg">
            Choisis entre un tableau de score en ligne gratuit ou l'application
            Android JudoScore Pro pour gérer les combats, les points, les
            pénalités et les chronomètres.
          </p>
        </div>

        <div className="mt-8 grid max-w-4xl gap-3 sm:grid-cols-3">
          <HeroStat icon={FaDesktop} label="En ligne" value="Gratuit" />
          <HeroStat icon={FaMobileAlt} label="Android" value="Google Play" />
          <HeroStat icon={FaStopwatch} label="Score" value="Judo" />
        </div>
      </div>
    </header>
  );
}

export default ScoreboardHero;